import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------dashboard page api's-------------------------------->
    getDashboard(data, token) {
        /**
         * dashboard details api
         * @param {*} data 
         */
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/index/dashboard', data)
    },
    postupdateTheme(data, token) {
        /**
         * dashboard details api
         * @param {*} data 
         */
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/index/usertheme', data)
    },
}